import StaffManagementCheckInSetupSubPage from "./staff-management-check-in-setup-sub-page";
import StaffManagementCheckInHistorySubPage from "./staff-management-check-in-history-sub-page";
import StaffManagementWorkersSubPage from "./staff-management-workers-sub-page";
import StaffManagementAttendanceSubPage from "./staff-management-attendance-sub-page";
import StaffManagementAuditLogSubPage from "./staff-management-audit-log-sub-page";


const StaffManagementSubPages = {
    CheckInSetup: StaffManagementCheckInSetupSubPage,
    CheckInHistory: StaffManagementCheckInHistorySubPage,
    Workers: StaffManagementWorkersSubPage,
    Attendance: StaffManagementAttendanceSubPage,
    AuditLog: StaffManagementAuditLogSubPage,
};

export default StaffManagementSubPages;
